module.exports = __webpack_public_path__ + "img/profile-my-songs.8c706464.svg";